import React,{useEffect} from 'react';

export default function ScrollToTop() {
    useEffect(()=>{

    } , []);
    return(<div> </div>)
}